import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/* ═══════════════════════════════════════════
   Placeholder — swap this for the real
   WhatsApp Business API call later.
   Keep the same signature so nothing else
   needs to change when you wire it up.
═══════════════════════════════════════════ */
const sendQueryToCareGuide = async (payload) => {
  console.log('Query payload (to be sent to WhatsApp later):', payload);
  // Simulate a network call
  await new Promise((resolve) => setTimeout(resolve, 700));
  return { success: true };
};

/* ── Success popup ── */
const SuccessModal = ({ onClose }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4"
    style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}
    onClick={onClose}
  >
    <div
      className="bg-white rounded-2xl w-full flex flex-col items-center text-center p-8 relative"
      style={{ maxWidth: '400px' }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="flex items-center justify-center rounded-full mb-5"
        style={{ width: 72, height: 72, backgroundColor: 'var(--ava-color-success-100, #dcfce7)', flexShrink: 0 }}
      >
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-success-base, #16a34a)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      </div>
      <h3 className="ava-heading-md mb-1">Query Sent!</h3>
      <p className="ava-text-sm mb-6" style={{ color: 'var(--text-light, #6b7280)' }}>
        Thanks for reaching out. Our care guide team will get back to you shortly on the number/email you provided.
      </p>
      <button
        onClick={onClose}
        className="w-full py-3 rounded-xl font-semibold text-sm transition-opacity hover:opacity-90 cursor-pointer"
        style={{ backgroundColor: 'var(--primary-color)', color: '#fff', border: 'none' }}
      >
        Done
      </button>
    </div>
  </div>
);

const TalkToCareGuide = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    query: '',
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [apiErr, setApiErr] = useState('');

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  // const validate = () => {
  //   const next = {};
  //   if (!form.name.trim()) next.name = 'Name is required';
  //   if (!/^\d{10}$/.test(form.mobile.trim())) next.mobile = 'Enter a valid 10-digit mobile number';
  //   if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
  //     next.email = 'Enter a valid email address';
  //   }
  //   if (!form.query.trim()) next.query = 'Please tell us how we can help';
  //   setErrors(next);
  //   return Object.keys(next).length === 0;
  // };
  const validate = () => {
    const next = {};

    if (!form.name.trim()) {
      next.name = "Name is required";
    }

    if (!/^[6-9]\d{9}$/.test(form.mobile.trim())) {
      next.mobile =
        "Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9";
    }

    if (
      form.email.trim() &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())
    ) {
      next.email = "Enter a valid email address";
    }

    if (!form.query.trim()) {
      next.query = "Please tell us how we can help";
    }

    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    setApiErr('');
    try {
      const res = await sendQueryToCareGuide({
        name: form.name.trim(),
        mobile: form.mobile.trim(),
        email: form.email.trim(),
        address: form.address.trim(),
        query: form.query.trim(),
      });
      if (res.success) {
        setShowSuccess(true);
      } else {
        setApiErr('Something went wrong. Please try again.');
      }
    } catch (err) {
      setApiErr(err?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
    setForm({ name: '', mobile: '', email: '', address: '', query: '' });
    navigate('/'); // send them back home after closing — change if you'd rather keep them here
  };
  const wordCount = form.query.trim()
    ? form.query.trim().split(/\s+/).length
    : 0;

  return (
    <section className="w-full py-10 md:py-16" style={{ backgroundColor: '#f9fafb' }}>
      <div className="container mx-auto px-4 md:px-8" style={{ maxWidth: 640 }}>

        <div className="mb-8 text-center">
          <h1 className="ava-heading-lg mb-2">Talk to a Care Guide</h1>
          <p className="ava-text-body" style={{ color: 'var(--text-light, #6b7280)' }}>
            Share a few details and our care guide will reach out to help — no need to hunt for a contact page.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl p-6 md:p-8 flex flex-col gap-5"
          style={{ border: '1px solid #e5e7eb' }}
        >
          {/* Name */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Full Name</label>
            <input
              type="text"
              placeholder="Your full name"
              value={form.name}
              onChange={handleChange('name')}
              className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors"
              style={{ border: errors.name ? '1.5px solid var(--ava-color-error-base, #dc2626)' : '1.5px solid #e5e7eb' }}
            />
            {errors.name && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base, #dc2626)' }}>{errors.name}</p>}
          </div>

          {/* Mobile */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Mobile Number</label>
            <div className="flex rounded-xl overflow-hidden" style={{ border: errors.mobile ? '1.5px solid var(--ava-color-error-base, #dc2626)' : '1.5px solid #e5e7eb' }}>
              <div className="flex items-center px-3 py-3 flex-shrink-0" style={{ backgroundColor: '#f3f4f6', borderRight: '1.5px solid #e5e7eb' }}>
                <span className="ava-text-sm" style={{ color: '#374151' }}>+91</span>
              </div>
              <input
                type="tel"
                placeholder="10-digit mobile number"
                value={form.mobile}
                maxLength={10}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, mobile: e.target.value.replace(/\D/g, '') }));
                  setErrors((prev) => ({ ...prev, mobile: '' }));
                }}
                className="flex-1 min-w-0 px-3 py-3 text-sm outline-none bg-white"
                style={{ border: 'none' }}
              />
            </div>
            {errors.mobile && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base, #dc2626)' }}>{errors.mobile}</p>}
          </div>

          {/* Email */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Email Address <span style={{ color: '#9ca3af' }}>(optional)</span></label>
            <input
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange('email')}
              className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors"
              style={{ border: errors.email ? '1.5px solid var(--ava-color-error-base, #dc2626)' : '1.5px solid #e5e7eb' }}
            />
            {errors.email && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base, #dc2626)' }}>{errors.email}</p>}
          </div>

          {/* Address */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Address <span style={{ color: '#9ca3af' }}>(optional)</span></label>
            <input
              type="text"
              placeholder="Your address"
              value={form.address}
              onChange={handleChange('address')}
              className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors"
              style={{ border: '1.5px solid #e5e7eb' }}
            />
          </div>

          {/* Query */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Description / Query</label>
            <textarea
              placeholder="Tell us how we can help..."
              value={form.query}
              onChange={handleChange('query')}
              rows={4}
              className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors resize-none"
              style={{ border: errors.query ? '1.5px solid var(--ava-color-error-base, #dc2626)' : '1.5px solid #e5e7eb' }}
            />
            <p className="text-xs text-gray-500 mt-1">
              {wordCount}/200 words
            </p>
            {errors.query && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base, #dc2626)' }}>{errors.query}</p>}
          </div>

          {apiErr && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base, #dc2626)' }}>{apiErr}</p>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 rounded-xl font-semibold text-sm transition-opacity hover:opacity-90 cursor-pointer"
            style={{
              backgroundColor: submitting ? '#9ca3af' : 'var(--primary-color)',
              color: '#fff',
              border: 'none',
              cursor: submitting ? 'wait' : 'pointer',
            }}
          >
            {submitting ? 'Sending…' : 'Submit Query'}
          </button>
        </form>
      </div>

      {showSuccess && <SuccessModal onClose={handleCloseSuccess} />}
    </section>
  );
};

export default TalkToCareGuide;